/**
 * The single canonical task-detail URL: `/projects/:projectId/tasks/:taskId`.
 * The route renders ONE unified `TaskDetail` for task, run, or exploration ids; the id kind
 * is resolved server-side by the task-detail envelope, never by the URL or a prefix switch. Every link
 * to a task's detail view should go through this helper so there is one source of truth for the route.
 */
export function taskDetailUrl(projectId: string, taskId: string): string {
  return `/projects/${projectId}/tasks/${taskId}`
}
